module.exports =
  '_LEGAL':
    'TITLE': '特定商取引法に基づく表示'


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/legal/i18n/ja.coffee